module.exports = __webpack_public_path__ + "static/ch7-SCRUB-02-9f8f4247a65ffcea0a7cb2963594f3d9.mp4";